import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        options: {
            customProperties: true
        },
        themes: {
            light: {
                primary: '#FFBB00',
                secondary: '#375E97',
                accent: '#FB6542',
                success: '#3F681C',
            },
            dark: {
                primary: '#FFBB00',
                secondary: '#375E97',
                accent: '#FB6542',
                success: '#3F681C',
            }
        },
        dark: false
    }
});
